import script from "./homeFAB.vue?vue&type=script&setup=true&lang=js"
export * from "./homeFAB.vue?vue&type=script&setup=true&lang=js"

import "./homeFAB.vue?vue&type=style&index=0&id=cd4b40cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd4b40cc"]])

export default __exports__